import React, { useState, useMemo } from "react";
import { ServiceType } from "../interfaces/types";
import { useParams, useNavigate } from "react-router-dom";

interface ServiceTypeListProps {
  onAddServiceType: () => void;
  // NUEVA PROP para recibir los tipos de servicio de la API
  serviceTypes: ServiceType[];
}

const ServiceTypeList: React.FC<ServiceTypeListProps> = ({
  onAddServiceType,
  // Desestructuramos la nueva prop
  serviceTypes,
}) => {
  const [statusFilter, setStatusFilter] = useState<
    "all" | "active" | "inactive"
  >("all");
  const navigate = useNavigate();
  // Lógica de filtrado
  const filteredServiceTypes = useMemo(() => {
    // *** USAMOS serviceTypes DE LAS PROPS ***
    // return serviceTypes
    return serviceTypes.filter((type) => {
      const statusMatch =
        statusFilter === "all" || type.status === statusFilter;
      return statusMatch;
    });
  }, [statusFilter, serviceTypes]);

  // Función para renderizar una tarjeta de tipo de servicio
  const renderServiceTypeCard = (type: ServiceType) => {
    const isActive = type.status === "active";
    const statusText = isActive ? "Activo" : "Inactivo";
    const statusClass = isActive
      ? "status-badge--active"
      : "status-badge--inactive";
    const activateButton = !isActive ? (
      <button className="btn btn--success">Activar</button>
    ) : (
      <></>
    );

    return (
      <div
        className="service-type-card"
        data-status={type.status}
        key={type.id}
      >
        <div className="service-type-card__header">
          <h3 className="service-type-card__title">{type.name}</h3>
          <span className={`status-badge ${statusClass}`}>{statusText}</span>
        </div>
        <div className="service-type-card__body">
          <p className="service-type-card__description">{type.description}</p>
        </div>
        <div className="service-type-card__footer">
          <div className="service-type-card__actions">
            <button
              className="btn btn--secondary"
              onClick={() => navigate(`/service-types/${type.id}`)}
            >
              Editar
            </button>
            {activateButton}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="filters" id="service-types-filters">
        <div className="filter-group">
          <label htmlFor="service-type-status-filter">Filtrar por Estado</label>
          <select
            id="service-type-status-filter"
            value={statusFilter}
            onChange={(e) =>
              setStatusFilter(e.target.value as "all" | "active" | "inactive")
            }
          >
            <option value="all">Todos los estados</option>
            <option value="active">Activos</option>
            <option value="inactive">Inactivos</option>
          </select>
        </div>
        <div className="filter-group">
          <label>&nbsp;</label>
          <button className="btn btn--primary" onClick={onAddServiceType}>
            <i className="fas fa-plus"></i> Agregar Tipo de Servicio
          </button>
        </div>
      </div>

      <div className="service-types-grid" id="service-types-container">
        {filteredServiceTypes.length > 0 ? (
          filteredServiceTypes.map(renderServiceTypeCard)
        ) : (
          <div className="empty-state">
            <i className="fas fa-search-minus empty-state__icon"></i>
            <h3>No se encontraron tipos de servicio</h3>
            <p>Ajusta el filtro o agrega un nuevo tipo.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceTypeList;
